import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useSiniestrosStore from '../store/siniestrosStore';
import { isEmpty } from '../utils/functions';
import gif from '../assets/img/maintenance_mode.jpg';

const InactiveScreen = () => {
	const navigate = useNavigate();
	const { config } = useSiniestrosStore();
	const [msg, setMsg] = useState('');

	useEffect(() => {
		if (!isEmpty(config.app_status_message)) {
			setMsg(config.app_status_message);
		}
	}, [config]);

	return (
		<div id="main_container" className="flex justify-center h-[100vh]">
			<div className="grid grid-cols-2 items-center max-w-screen-lg h-full gap-6">
				<div className="flex flex-col ps-4">
					<h1 className="text-start text-primary font-bold text-2xl uppercase">NOS ENCONTRAMOS TRABAJANDO</h1>
					<p className="text-start text-black font-normal text-lg">{msg}</p>
					<p className='mt-4 mb-1 text-grey-tx font-normal text-base text-start'>Vas a poder realizar tu reclamo desde el siguiente botón</p>
					<div className='mt-2 w-full text-start'>
						<a href='https://forms.gle/fxxfSyrqFQrgs3Tt5' target='_blank' rel='noreferrer' className='text-white uppercase font-semibold bg-primary hover:bg-light-red outline-none rounded-md py-2  px-2 md:px-12 text-center'>realizar reclamo</a>
					</div>
				</div>
				<div className="flex pe-4">
					<img id="main_img" src={gif} className='w-full' alt="maintenance_mode_gif" />
				</div>
			</div>
		</div>
	);
}

export default InactiveScreen